import { LeftRightDesginIcon } from '@Components/Common/CommonMethods';
import DialogComponent from '@Components/Common/DialogComponent';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

const KitOrderListing = ({ kitListingState, openKitPopup, setOpenKitPopup }) => {
    const { register, errors, handleSubmit, setError } = useForm({ mode: 'onChange' });
    return (
        <LeftRightDesginIcon>
            <form className='signupform main-sign-frm form-kit' onSubmit={handleSubmit((data) => kitListingState?.handleSubmit(data, setError))}>
                <h5>SNiP Test Kit Registration Form</h5>
                <div className='input_field'>
                    <label htmlFor='normal' style={{ color: "#fff" }}>
                        Enter the code printed on the vials inside your DNA test kit.
                        Please continue if you are the individual who is providing the
                        DNA sample.
                    </label>
                    <input type="text" name="barCode" className='form-control' ref={register({ required: "this field is required" })} />
                    {errors?.barCode && <span className='error'>{errors?.barCode?.message}</span>}
                </div>

                <div className='Sample-instructions'>
                    <a className='DNA Sample-instructions' href='https://admin.snipnutrition.com/media/documents/Welcome_Instructions_02032025.pdf'
                        target='_blank'>Tap here for DNA test instructions.</a>
                </div>
                <div className="go_to_next">
                    <button type='submit' style={{ color: '#fff' }}>Next</button>
                </div>
                { }
                {/* {(kitListingState?.barCodeVerify) && <span className='success'>Verified</span>} */}
            </form>
            <DialogComponent opend={openKitPopup} handleClose={() => setOpenKitPopup(false)} classFor="already_registered_a_kit">
                <p style={{ textAlign: "center" }}>{errors?.barCode?.message}</p>
            </DialogComponent>
        </LeftRightDesginIcon>
    )
};

export default KitOrderListing;